// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1oaxq","dragIcon":"Choice_dragIcon__2RjfD","left":"Choice_left__W2vjB","input":"Choice_input__z6PbG"};